import(/* webpackMode: "eager" */ "/app/apps/press-cms/app/global-error.tsx");
